import { Card, CardContent } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import { Route, Routes } from 'react-router-dom'
import userStore from 'store/userStore'
import { CustomDescrypt } from 'global/func'
import { decodeToken } from 'react-jwt'
import { useEffect, useState } from 'react'
import { getDataWithResponse } from 'global/getFunc'
import RincianBelanja from './RincianBelanja'
import Komponen from './Komponen'
import TabelPelaporan from 'examples/Tables/TabelPelaporan'

const LaporanBelanja = () => {
    return (
        <Routes>
            <Route path="" element={<Data />} />
            <Route path="rincian-belanja" element={<RincianBelanja />} />
            <Route path="komponen" element={<Komponen />} />
        </Routes>
    )
}

const Data = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const reqPerencanaan = () => {
        setLoading(true)
        addReq()
        getDataWithResponse(
            `/admin-opd/get-tr-perencanaan-opd-2/${tahunAnggaran.ta}/${decodedUser.kd_pd}`,
            decryptedUser,
            (res) => {
                setData(res)
                setLoading(false)
                console.log(res);
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }
        );
    }

    useEffect(() => {
        console.log(tahunAnggaran);
        reqPerencanaan();
        // setData(reqData(tahunAnggaran.ta, decodedUser.kd_pd))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={1}>
                <Card>
                    <CardContent>
                        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" py={2}>
                            <ArgonTypography variant="h6">Tabel Program</ArgonTypography>
                        </ArgonBox>
                        <ArgonBox
                            sx={{
                                "& .MuiTableRow-root:not(:last-child)": {
                                    "& td": {
                                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                            `${borderWidth[1]} solid ${borderColor}`,
                                    },
                                },
                            }}
                        >
                            <TabelPelaporan
                                data={data}
                                loading={loading}
                                baseUrl='/a-pd/laporan-belanja'
                            />
                        </ArgonBox>
                    </CardContent>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default LaporanBelanja